import { persistor } from "./store";

/**
 * Clears all persisted Redux state from sessionStorage
 * Useful for testing or when users need to restart the application flow
 */
export const clearPersistedState = async (): Promise<void> => {
    try {
        await persistor.purge();
    } catch (error) {
        console.error("Failed to clear persisted state:", error);
    }
};

/**
 * Manually trigger state persistence
 * Usually not needed as redux-persist handles this automatically
 */
export const flushPersist = async (): Promise<void> => {
    try {
        await persistor.flush();
    } catch (error) {
        console.error("Failed to flush persisted state:", error);
    }
};
